import {
  fetchParentchildren,
  fetchPatientRecord,
  fetchGetRecordNames,
  fetchGetRecordName,
  fetchChildFields,
  fetchSiblings,
  fetchParent,
  fetchParentChildren,
  fetchWholeRecord,
  fetchFindIndex,
  deleteFromCollection,
  fetchFilteredCollection,
  updateRec,
} from '../api';

export const actions = {
  updatePatientData({ commit, state }, collection, nodeMap) {
    commit('FORMAT_NODE_UPDATE', nodeMap);
    if (!state.nodeMapForUpload) {
      return;
    }
    updateRec(state.nodeMapForUpload).then((collection, patientData) => {
      commit('UPDATE_PATIENT_DATA', patientData);
    });
  },
  loadPatientData({ commit }, patientId) {
    fetchPatientRecord(patientId).then((patientData) => {
      commit('LOAD_PATIENT_DATA', patientData);
    });
  },
  viewGetRecordNames({ commit }, params) {
    fetchGetRecordNames(params).then((data) => {
      commit('LOAD_VIEW_DATA', data);
    });
  },
  viewGetRecordName({ commit }, params) {
    fetchGetRecordName(params).then((data) => {
      commit('LOAD_VIEW_DATA', data);
    });
  },
  viewGetChildren({ commit }, params) {
    fetchChildFields(params).then((data) => {
      commit('LOAD_VIEW_DATA', data);
    });
  },
  viewGetSiblings({ commit }, params) {
    fetchSiblings(params).then((data) => {
      commit('LOAD_VIEW_DATA', data);
    });
  },
  viewGetParent({ commit }, params) {
    fetchParent(params).then((data) => {
      commit('LOAD_VIEW_DATA', data);
    });
  },
  viewGetParentChildren({ commit }, params) {
    fetchParentChildren(params).then((data) => {
      commit('LOAD_VIEW_DATA', data);
    });
  },
  viewGetWholeRecord({ commit }, params) {
    fetchWholeRecord(params).then((data) => {
      commit('LOAD_VIEW_DATA', data);
    });
  },
};
